import html2canvas from 'html2canvas';

const WRAPPERID = 'wrapper-element-for-screenshot';

export async function downloadImage (element, filename, options = {}, exportAction = 'download') {
    const clonedElement = cloneElement(element, options);
    const { width } = options;
    /**
     * added ignoreElements for the vue-wrapper as it caused the
     * vue lifecycle hooks to run and remounted some components
     * this caused some issues with components such as drawers
     */
    const config = {
        ...(width && { width }),
        ignoreElements: (el) => {
            const ignoreElementsByClassName = options.ignoreElementsByClassName || [];

            return el.nodeName === 'VUE-WRAPPER' || ignoreElementsByClassName.includes(el.className);
        },
    };

    const canvas = await html2canvas(clonedElement, config);
    if (exportAction === 'download') {
        const url = canvas.toDataURL('image/png');
        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.download = filename;
        downloadLink.click();
        downloadLink.remove();
        document.getElementById(WRAPPERID).remove();
    }
    if (exportAction === 'copy') {
        return canvas.toBlob((blob) => {
            navigator.clipboard
                .write([
                    new ClipboardItem(
                        Object.defineProperty({}, blob.type, {
                            value: blob,
                            enumerable: true,
                        }),
                    ),
                ])
                .finally(() => {
                    document.getElementById(WRAPPERID).remove();
                });
        });
    }

    return canvas;
}

export async function copyText (element, options = {}) {
    const clonedElement = cloneElement(element, options);
    const ignoreElementsByClassName = [...(options.ignoreElementsByClassName || []), 'do-not-copy'];

    ignoreElementsByClassName.forEach((className) => {
        clonedElement.querySelectorAll(`.${className}`).forEach((element) => element.parentNode.removeChild(element));
    });

    const blobHtml = new Blob([clonedElement.innerHTML], { type: 'text/html' });
    const blobText = new Blob([clonedElement.innerText], { type: 'text/plain' });
    const data = [
        new ClipboardItem({
            'text/plain': blobText,
            'text/html': blobHtml,
        }),
    ];

    return navigator.clipboard.write(data).finally(() => {
        document.getElementById(WRAPPERID).remove();
    });
}

function cloneElement (element, options) {
    const clonedElement = element.cloneNode(true);
    clonedElement.id = WRAPPERID;
    const { width, addTags, title, expandTables, alignTitle = 'center' } = options;
    if (width) {
        let style = '';
        if (width) {
            style += `width: ${width}px;`;
        }
        style += ' height: auto';
        clonedElement.removeAttribute('style');
        clonedElement.setAttribute('style', style);
    }
    clonedElement.classList.add('print-version');
    if (options.class) clonedElement.classList.add(...options.class.split(' '));
    addTitle(clonedElement, title, alignTitle);
    addAdditionalTags(clonedElement, addTags);
    document.body.appendChild(clonedElement);
    if (expandTables) {
        expandPendoTables();
    }

    return clonedElement;
}

function addTitle (clonedElement, title, textAlign = 'center') {
    if (!title) return;

    const titleElement = document.createElement('h5');
    titleElement.innerText = title;
    titleElement.style.textAlign = textAlign;
    titleElement.style.fontFamily = 'Inter';
    clonedElement.prepend(titleElement);
}

export function addAdditionalTags (clonedElement, tags = []) {
    const widgetWrapper =
        clonedElement.querySelectorAll('.widget-tags')[0] || clonedElement.querySelectorAll('.goal-tag-group')[0];
    if (!tags.length || !widgetWrapper) {
        return;
    }

    for (let i = 0; i < tags.length; i++) {
        const dateTag = document.createElement('span');
        dateTag.classList.add('pendo-tag', 'pendo-tag--filter', 'pendo-tag--medium');
        const span = document.createElement('span');
        const labelSpan = document.createElement('span');
        labelSpan.classList.add('filter-tag-label');
        const label = document.createTextNode(tags[i]);
        labelSpan.appendChild(label);
        span.appendChild(labelSpan);
        dateTag.appendChild(span);
        widgetWrapper.prepend(dateTag);
    }
}

function expandPendoTables () {
    const tableBodies = document.querySelectorAll(`#${WRAPPERID} .pendo-table__body`);
    const tables = document.querySelectorAll(`#${WRAPPERID} .pendo-table`);
    tableBodies.forEach((table) => {
        table.removeAttribute('style');
    });
    tables.forEach((table) => {
        table.removeAttribute('style');
    });
}
